import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "components/ui/Header";
// Add your imports here
import Homepage from "pages/homepage";
import FeaturedProjects from "pages/featured-projects";
import InsightsBlog from "pages/insights-blog";
import ServicesOverview from "pages/services-overview";
import CareersHub from "pages/careers-hub";
import ContactEngagement from "pages/contact-engagement";
import NotFound from "pages/NotFound";
import AboutUs from "pages/about-us";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Header />
        <ScrollToTop />
        <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/featured-projects" element={<FeaturedProjects />} />
        <Route path="/insights-blog" element={<InsightsBlog />} />
        <Route path="/services-overview" element={<ServicesOverview />} />
        <Route path="/careers-hub" element={<CareersHub />} />
        <Route path="/contact-engagement" element={<ContactEngagement />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;